module.exports = __webpack_public_path__ + "img/introduce1.f5a298ba.png";